
    import { computed, defineComponent, type PropType } from 'vue'

    import { staffData } from '@/common/json-ld/organization'
    import type { UserBasicData } from '@/common/models/data/common/user'

    export default defineComponent({
        props: {
            user: {
                type: Object as PropType<UserBasicData>,
                required: true
            }
        },
        setup (props) {
            return {
                jsonLd: computed(() => staffData(props.user))
            }
        }
    })
